import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { BranchIntParams } from '../models/branch-international.model';
import { AvailabilityInternationalResponse } from '../models/branch-international-response.model';
import { BranchesInternationalRepository } from '../repositories/branches-international.repository';

export class GetAvailabilityInternationalUseCase
    implements UseCase<BranchIntParams, AvailabilityInternationalResponse>
{
    constructor(private readonly repository: BranchesInternationalRepository) {}

    execute(
        searchTerm: BranchIntParams,
    ): Observable<AvailabilityInternationalResponse> {
        return this.repository.getAvailabilityInternational(searchTerm);
    }
}
